import { Component, Input, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { CommonModule } from '@angular/common';
import { BinCollectionPie } from './bin-collection-pie/bin-collection-pie';
import { BinCollectionHistory } from './bin-collection-history/bin-collection-history';
import { BinAnalytics } from './bin-analytics/bin-analytics';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bin-collection',
  imports: [CommonModule,BinCollectionPie,BinCollectionHistory,BinAnalytics],
  templateUrl: './bin-collection.html',
  styleUrl: './bin-collection.scss',
})
export class BinCollection {
  @Input() binInfo;
	isMobile: boolean;
	translationsObj;
	currentLang;
  private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }
}
